//let api="http://hy.xiaoqinhaishen.com";
let api="";
let session = localStorage.getItem('session');

function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}


if(!session){
    session = uuid();
    localStorage.setItem('session',session);
}

export function Fetch(url,options,callback){
    
    if(!options.data){
        options.data = {};
    }
    
    if(options.method == "GET"){
        fetch(url, {
            method: options.method, 
            cache: 'default',
            headers: {
                'Content-Type': 'application/json',
                'session': session
            },
        }).then(function(res){
            return res.json();
        }).then(callback);
    }
    else{
        fetch(url, {
            method: options.method, 
            cache: 'default',
            body:JSON.stringify(options.data),
            headers: {
                'Content-Type': 'application/json',
                'session': session
            },
        }).then(function(res){
            return res.json();
        }).then(callback);
    }
}

export function Auth_Login(param,callback){
	Fetch(api + `/api/Auth/Login?mobile=${param.mobile}&checkCode=${param.checkCode}&r=${Math.random()}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function Auth_IsLogin(param,callback){
	Fetch(api + `/api/Auth/IsLogin`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function Auth_SendSms(param,callback){
	Fetch(api + `/api/Auth/SendSms?mobile=${param.mobile}&r=${Math.random()}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function Auth_Logout(param,callback){
	Fetch(api + `/api/Auth/Logout`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function Basic_SysInfo(param,callback){
	Fetch(api + `/api/Basic/SysInfo`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function Current(param,callback){
	Fetch(api + `/api/contact/Current`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function OrderDs(param,callback){
	Fetch(api + `/api/OrderDs/Query`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function OrderDsDetail(param,callback){
	Fetch(api + `/api/OrderDs/Detail/${param.ID}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}

export function OrderInOut(param,callback){
	Fetch(api + `/api/OrderInOut/Query`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function OrderInOutDetail(param,callback){
	Fetch(api + `/api/OrderInOut/Detail/${param.ID}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function OrderInOutStock(param,callback){
	Fetch(api + `/api/OrderInOut/Contact`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function IsWxBind(param,callback){
	Fetch(api + `/api/Auth/IsWxBind?session=${session}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function Auth_Wx(param,callback){
	Fetch(api + `/api/Auth/Wx?session=${session}&code=${param.code}&state=${param.state}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Verify(param,callback){
	Fetch(api + `/api/GiftOrder/Verify`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Order(param,callback){
	Fetch(api + `/api/GiftOrder/Order`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_OrderDetail(param,callback){
	Fetch(api + `/api/GiftOrder/Detail/${param.ID}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Query(param,callback){
	Fetch(api + `/api/GiftOrder/Query`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Birth(param,callback){
	Fetch(api + `/api/GiftOrder/Birth`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Campaign(param,callback){
	Fetch(api + `/api/GiftOrder/Campaign`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function GiftOrder_Current(param,callback){
	Fetch(api + `/api/GiftOrder/Current/${param.ID}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function City(param,callback){
	Fetch(api + `/api/Basic/zz_cityinfo?parentid=${param.ID}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function OrderInOut_CheckCode(param,callback){
	Fetch(api + `/api/OrderInOut/CheckCode`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function SysPay_StartPay(param,callback){
	Fetch(api + `/api/SysPay/StartPay`,{
        method:"POST",
		data:param,
    },function(res){
        callback(res);
    });
}
export function WxPay_WxAppKey(param,callback){
	Fetch(api + `/api/WxPay/WxAppKey?iddep=${param.iddep}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}
export function WxPay_WxCallBack(param,callback){
	Fetch(api + `/api/WxPay/WxCallBack?iddep=${param.iddep}&code=${param.code}&state=${param.state}`,{
        method:"GET",
		data:param,
    },function(res){
        callback(res);
    });
}


// WEBPACK FOOTER //
// ./src/api/api.js